import { lazy } from 'react';

import { KhodroShakhsSalesPaths } from 'Feature/Khodro/ShakhsSales/Routes/Paths/KhodroShakhsSalesPaths';
import IRoute from 'Shared/Routes/Models/IRoute';

const ShakhsSalesBimehNamehDetailPage = lazy(
  () => import('Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Pages/Detail/ShakhsSalesBimehNamehDetailPage')
);
const SodoorBimehNamehByPelakPage = lazy(
  () => import('../../SakhsSalesBimehNameh/Pages/SodoorBimehNamehByPelak/SodoorBimehNamehByPelakPage')
);
const ShakhsSalesEstelamAndSodoorPage = lazy(
  () => import('../../SakhsSalesBimehNameh/Pages/EstelamAndSodoor/ShakhsSalesEstelamAndSodoorPage')
);
const SodoorBimehNamehByTavizPelakPage = lazy(
  () => import('../../SakhsSalesBimehNameh/Pages/SodoorBimehNamehByTavizPelak/SodoorBimehNamehByTavizPelakPage')
);
const ElhaghiyehSaderehDetailPage = lazy(
  () => import('../../SakhsSalesBimehNameh/Pages/ElhaghiyehSaderehDetail/ElhaghiyehSaderehDetailPage')
);

const ShakhSalesRoute: IRoute[] = [
  {
    path: KhodroShakhsSalesPaths.BimehNameh.Tamdid,
    component: SodoorBimehNamehByPelakPage,
    needAuth: true,
  },
  {
    path: KhodroShakhsSalesPaths.BimehNameh.SodoorByPelak,
    component: SodoorBimehNamehByPelakPage,
    needAuth: true,
  },
  {
    path: KhodroShakhsSalesPaths.BimehNameh.Detail,
    component: ShakhsSalesBimehNamehDetailPage,
    needAuth: true,
  },
  {
    path: KhodroShakhsSalesPaths.BimehNameh.EstelamAndSodoor,
    component: ShakhsSalesEstelamAndSodoorPage,
    needAuth: true,
  },
  {
    path: KhodroShakhsSalesPaths.BimehNameh.SodoorByTavizPelak,
    component: SodoorBimehNamehByTavizPelakPage,
    needAuth: true,
  },
  {
    path: KhodroShakhsSalesPaths.BimehNameh.ElhaghiyehSaderehDetail,
    component: ElhaghiyehSaderehDetailPage,
    needAuth: true,
    parameters: ['gharardadBimehId'],
  },
];

export default ShakhSalesRoute;
